import { lakewoodConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function LakewoodNJPage() {
  return <CityPageTemplate config={lakewoodConfig} />;
}